/**
 * The administrator is told (#420): at sign-in, when places or drivers' reports wait for
 * their approval, one line under the bar — *3 адреса чакат одобрение* — that opens the list.
 *
 * Once per sign-in rather than for good: put away, it stays away until the next time they
 * sign in, and the count beside Адреси in the settings sidebar keeps saying it meanwhile. Not
 * shown on the Адреси page itself, where the list is.
 */

import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import { usePreferences } from '../shell/preferencesContext';
import { Banner, Button } from '../ui';
import { useWaitingPlaces } from './useWaitingPlaces';

/** Remembered for the tab's session, which a sign-in starts. */
const PUT_AWAY = 'taxi.places-notice-put-away';

function putAway(): boolean {
  try {
    return sessionStorage.getItem(PUT_AWAY) === '1';
  } catch {
    return false;
  }
}

export function WaitingNotice() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { access } = usePreferences();

  const waiting = useWaitingPlaces(access.settings);
  const [away, setAway] = useState(putAway);

  if (away || waiting === null || waiting === 0 || pathname.startsWith('/settings/places')) return null;

  const dismiss = () => {
    try {
      sessionStorage.setItem(PUT_AWAY, '1');
    } catch {
      // A browser that keeps nothing shows it again next time; that is all.
    }

    setAway(true);
  };

  return (
    <Banner tone="warn" className="mx-3 mt-2">
      <span className="flex flex-wrap items-center justify-between gap-2 w-full">
        <span>{t('places.notice', { count: waiting })}</span>
        <span className="flex gap-2">
          <Button
            variant="primary"
            onClick={() => {
              dismiss();
              navigate('/settings/places');
            }}
          >
            {t('places.noticeOpen')}
          </Button>
          <Button onClick={dismiss}>{t('places.noticeLater')}</Button>
        </span>
      </span>
    </Banner>
  );
}
